import { Component } from '@theme/component';

/**
 * Wraps the state-collection-ranches sort form. Reproduces the FindARancherDemo
 * ResultsBar sort <select>'s only behavior — StateCollectionPage.tsx does not
 * re-sort client-side, it just tracks `sortKey` state — so the Liquid port
 * reloads the page with the new `sort_by` whenever the value changes, letting
 * it drive the collection's native sort; other query params are kept.
 *
 * @typedef {object} Refs
 * @property {HTMLSelectElement} select - The sort_by <select> element.
 *
 * @extends {Component<Refs>}
 */
class CollectionSortFormComponent extends Component {
  requiredRefs = ['select'];

  #abortController = new AbortController();

  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#abortController;
    this.refs.select.addEventListener('change', this.#reloadOnSortChange, { signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController.abort();
  }

  /**
   * Reloads the page with the new `sort_by` when the sort option changes,
   * keeping the rest of the query string (the ranch filters live there — the
   * demo sorts in memory, so its filters survive a sort change).
   */
  #reloadOnSortChange = () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', this.refs.select.value);
    window.location.assign(url);
  };
}

if (!customElements.get('collection-sort-form')) {
  customElements.define('collection-sort-form', CollectionSortFormComponent);
}
